module.exports = __webpack_public_path__ + "static/media/img4.a71df6d4.jpg";